import React, { memo, useState, useEffect } from "react";
import FullWordModel from "../../common/FullWordModel";
import { usePreference } from "../../context/UserContext";

const ScoreModal = ({
  tanswers,
  dictionary,
  questions,
  openAswers,
  setOpenAnswers,
}) => {

   const {
       isOpenWordInfo,
        updateIsOpenWordInfo
    } = usePreference();

  const [currentquestion, setCurrentQuestion] = useState({});
  // Define the non-printable separator for '|'
  const separator1 = "\x01\x1F"; // Start of Heading + Unit Separator for '|'

  const handleClick = (e) => {
    updateIsOpenWordInfo(true);
    // let foundItem = questions.find((item) => item.Id == e.split("|")[1]);

    // Replace the pipe (|) separator with the non-printable separator
    let foundItem = questions.find((item) => item.Id == e.split(separator1)[1]);
    setCurrentQuestion(foundItem);
  };

  

  const closeModal = () => {
    setOpenAnswers(false);
  };

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          height: "100vh",
          width: "100vw",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: openAswers ? "flex" : "none",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            width: "90%",
            maxWidth: "600px",
            maxHeight: "70vh",
            overflowY: "auto",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0 0 10px rgba(0,0,0,0.3)",
            position: "relative",
          }}
        >
          <div style={{ marginBottom: "10px", textAlign: "center" }}>
            <div style={{ marginBottom: "10px" }}>
              (*Click on any answer to see full information for the word)
            </div>
            <span
              style={{
                position: "absolute",
                top: "10px",
                right: "15px",
                fontSize: "24px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={closeModal}
            >
              &times;
            </span>
            <label
              style={{
                textDecoration: "underline",
                fontWeight: "bold",
                fontSize: "28px",
              }}
            >
              {/* title */}
            </label>
          </div>

          <div>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                border: "1px solid #ccc",
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      padding: "10px",
                      textAlign: "left",
                      border: "1px solid #ccc",
                      backgroundColor: "#f2f2f2",
                    }}
                  >
                    Your Answer
                  </th>
                  <th
                    style={{
                      padding: "10px",
                      textAlign: "left",
                      border: "1px solid #ccc",
                      backgroundColor: "#f2f2f2",
                    }}
                  >
                    Actual Answer
                  </th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(dictionary).map(([key, value]) => {
                  if (typeof value !== "string" || !value.trim()) return null;

                  const userAnswer = value.toLocaleLowerCase();
                  const actualAnswer =
                    key.split(separator1)[2]?.toLocaleLowerCase() || "";
                  const isCorrect = userAnswer === actualAnswer;

                  return (
                    <tr key={key}>
                      <td
                        onClick={() => handleClick(key)}
                        style={{
                          padding: "10px",
                          color: isCorrect ? "green" : "red",
                          cursor: "pointer",
                          border: "1px solid #ccc",
                        }}
                      >
                        {value}
                      </td>
                      <td
                        onClick={() => handleClick(key)}
                        style={{
                          padding: "10px",
                          color: "green",
                          cursor: "pointer",
                          textDecoration: "underline",
                          border: "1px solid #ccc",
                        }}
                      >
                        {key.split(separator1)[2] || ""}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <FullWordModel
        open={isOpenWordInfo}
        updateIsOpen={updateIsOpenWordInfo}
        selectedid={currentquestion}
      />
    </>
  );
};

export default memo(ScoreModal);
